import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AiCreatePostModalService } from '@features/posts/services/ai-create-post-modal.service';

@Component({
  selector: 'app-step-success',
  standalone: true,
  templateUrl: './step-success.component.html',
  styleUrl: './step-success.component.scss',
})
export class StepSuccessComponent {
  protected readonly service = inject(AiCreatePostModalService);
  private readonly router = inject(Router);

  weekDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  action = this.service.lastAction;
  actionCount = this.service.lastActionCount;
  selectedAccounts = this.service.selectedAccountUuids;

  get successTitle(): string {
    switch (this.action()) {
      case 'queue':
        return 'Added to posting schedule!';
      case 'scheduled':
        return 'Posts scheduled!';
      default:
        return 'Drafts saved successfully!';
    }
  }

  get successSubtitle(): string {
    const postText = `${this.actionCount()} post${this.actionCount() === 1 ? '' : 's'}`;
    const accountText = `${this.selectedAccounts().length} account${
      this.selectedAccounts().length === 1 ? '' : 's'
    }`;
    switch (this.action()) {
      case 'queue':
        return `${postText} will use your workspace posting times for ${accountText}.`;
      case 'scheduled':
        return `${postText} scheduled for ${accountText}. Open the calendar to review publish dates.`;
      default:
        return `${postText} saved to drafts${accountText ? ` for ${accountText}` : ''}. Open your drafts list to review and schedule them.`;
    }
  }

  get primaryActionLabel(): string {
    switch (this.action()) {
      case 'queue':
        return 'Done';
      case 'scheduled':
        return 'View calendar';
      default:
        return 'View drafts';
    }
  }

  onPrimaryAction() {
    if (this.action() === 'queue') {
      this.service.closeModal();
      return;
    }
    this.onViewSavedPosts();
  }

  onViewSavedPosts() {
    this.service.closeModal();
    if (this.action() === 'scheduled') {
      this.router.navigate(['/planner/calendar']);
      return;
    }
    this.router.navigate(['/planner/list'], { queryParams: { selectedTab: 'draft' } });
  }

  onCreateAnother() {
    this.service.reset();
    this.service.openModal();
  }
}
